import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services/ApiClient';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { ReceptionApiAdapter } from '../adapters/ReceptionApiAdapter';
import { IdentifyPackageRequest, Package } from '../models/Reception';
import { ReceptionService } from '../services/ReceptionService';

interface IdentifyPackageParams {
  receptionId: number;
  pkg: Package;
  receptionStatus: string;
  data: IdentifyPackageRequest;
}

/**
 * Hook para identificar un paquete
 */
export const useIdentifyPackage = () => {
  const queryClient = useQueryClient();
  const httpClient = createHttpClient(apiClientWH);
  const apiAdapter = new ReceptionApiAdapter(httpClient);
  const receptionService = new ReceptionService(apiAdapter);

  return useMutation({
    mutationFn: ({ receptionId, pkg, receptionStatus, data }: IdentifyPackageParams) =>
      receptionService.identifyPackage(receptionId, pkg, receptionStatus, data),
    onSuccess: (updatedReception) => {
      // Invalidar queries de lista
      queryClient.invalidateQueries({ queryKey: ['receptions'] });
      queryClient.invalidateQueries({ queryKey: ['receptions-simple'] });
      // Actualizar el cache del detalle con la respuesta
      queryClient.setQueryData(['reception', updatedReception.id], updatedReception);
    },
  });
};

